import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'bn',
  months: [
    'জানুয়ারী',
    'ফেব্রুয়ারী',
    'মার্চ',
    'এপ্রিল',
    'মে',
    'জুন',
    'জুলাই',
    'আগস্ট',
    'সেপ্টেম্বর',
    'অক্টোবর',
    'নভেম্বর',
    'ডিসেম্বর',
  ],
  monthsShort: ['জানু', 'ফেব', 'মার্চ', 'এপ্রি', 'মে', 'জুন', 'জুল', 'আগ', 'সেপ', 'অক্টো', 'নভে', 'ডিসে'],
  weekdays: ['রবিবার', 'সোমবার', 'মঙ্গলবার', 'বুধবার', 'বৃহস্পতিবার', 'শুক্রবার', 'শনিবার'],
  weekdaysMin: ['র', 'সো', 'ম', 'বু', 'বৃ', 'শু', 'শ'],
  weekdaysShort: ['রবি', 'সোম', 'মঙ্গল', 'বুধ', 'বৃহস্পতি', 'শুক্র', 'শনি'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM, YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s বছর পূর্বে', other: '%s বছর পূর্বে' },
    M: { one: '%s মাস আগে', other: '%s মাস আগে' },
    w: { one: '%s সপ্তাহ আগে', other: '%s সপ্তাহ আগে' },
    d: { one: '%s দিন আগে', other: '%s দিন আগে' },
    h: { one: '%s ঘন্টা আগে', other: '%s ঘন্টা আগে' },
    m: { one: '%s মিনিট আগে', other: '%s মিনিট আগে' },
    s: { one: '%s সেকেন্ড পূর্বে', other: '%s সেকেন্ড পূর্বে' },
  },
  future: {
    y: { one: '%s বছরে', other: '%s বছরে' },
    M: { one: '%s মাসে', other: '%s মাসে' },
    w: { one: '%s সপ্তাহে', other: '%s সপ্তাহে' },
    d: { one: '%s দিনের মধ্যে', other: '%s দিনের মধ্যে' },
    h: { one: '%s ঘন্টায়', other: '%s ঘন্টায়' },
    m: { one: '%s মিনিটে', other: '%s মিনিটে' },
    s: { one: '%s সেকেন্ডে', other: '%s সেকেন্ডে' },
  },
  abbr: {
    y: { one: '%sবছর', other: '%sবছর' },
    M: { one: '%sমাস', other: '%sমাস' },
    w: { one: '%sসপ্তাহ', other: '%sসপ্তাহ' },
    d: { one: '%sদিন', other: '%sদিন' },
    h: { one: '%sঘঃ', other: '%sঘঃ' },
    m: { one: '%sমিঃ', other: '%sমিঃ' },
    s: { one: '%sসেঃ', other: '%sসেঃ' },
  },
  justNow: 'এইমাত্র',
  yesterday: 'গতকাল',
  today: 'আজ',
  tomorrow: 'আগামীকাল',
  weekStart: 0,
};
const localeName: LocaleName = 'bn';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
